import { getServiceURL, requestHandler } from "../utils/apiUtils";
import { L12M } from "../utils/constants/filterConstants";
// todo unused
import type { IListing } from "../views/interfaces";

export class CommonAPI {
  static get getUniqueReservationsServiceName() {
    return "GET_UNIQUE_RESERVATIONS";
  }

  static get getGuestsHostedServiceName() {
    return "GET_HOSTED_GUESTS";
  }

  static get getTotalBookedNightsServiceName() {
    return "GET_NUMBER_OF_BOOKED_NIGHTS";
  }

  static get getNetReservationIncomeServiceName() {
    return "GET_NET_RESERVATION_INCOME";
  }

  static get getPerformanceSummaryServiceName() {
    return "GET_PERFORMANCE_SUMMARY";
  }

  static get getPerNightRevenueServiceName() {
    return "GET_REVENUE_PER_AVAILABLE_NIGHT";
  }

  static get getRevenueByYearServiceName() {
    return "GET_REVENUE_BY_YEAR";
  }

  static get getRatingReviewsServiceName() {
    return "GET_RATING_REVIEWS";
  }

  static get getReservationsSummaryServiceName() {
    return "GET_RESERVATIONS_SUMMARY";
  }

  static get getListingsDataServiceName() {
    return "GET_LISTINGS_DATA";
  }

  static async getUniqueReservations(params?: {
    param?: string;
  }): Promise<object[]> {
    const url = getServiceURL(CommonAPI.getUniqueReservationsServiceName);
    const response = await requestHandler(url, params);
    return response?.data;
  }

  static async getGuestsHosted(params?: { param?: string }): Promise<object> {
    const url = getServiceURL(CommonAPI.getGuestsHostedServiceName);
    const response = await requestHandler(url, params || { param: L12M });
    return response?.data;
  }

  static async getTotalBookedNights(params?: {
    param?: string;
  }): Promise<number> {
    const url = getServiceURL(CommonAPI.getTotalBookedNightsServiceName);
    const response = await requestHandler(url, params || { param: L12M });
    return response?.data;
  }

  static async getNetReservationIncome(params?: {
    param?: string;
  }): Promise<number> {
    const url = getServiceURL(CommonAPI.getNetReservationIncomeServiceName);
    const response = await requestHandler(url, params);
    return response?.data;
  }

  static async getPerformanceSummary(params?: string[]): Promise<object> {
    const url = getServiceURL(CommonAPI.getPerformanceSummaryServiceName);
    const response = await requestHandler(url, { properties: params });
    return response?.data;
  }

  static async getPerNightRevenue(params?: string[]): Promise<object> {
    const url = getServiceURL(CommonAPI.getPerNightRevenueServiceName);
    const response = await requestHandler(url, { properties: params });
    return response?.data;
  }

  static async getRevenueByYear(params?: string[]): Promise<object> {
    const url = getServiceURL(CommonAPI.getRevenueByYearServiceName);
    const response = await requestHandler(url, { properties: params });
    return response?.data;
  }

  static async getRatingReviews(params?: string[]): Promise<object> {
    const url = getServiceURL(CommonAPI.getRatingReviewsServiceName);
    const response = await requestHandler(url, { properties: params });
    return response?.data;
  }

  static async getReservationsSummary(params?: string[]): Promise<object> {
    const url = getServiceURL(CommonAPI.getReservationsSummaryServiceName);
    const response = await requestHandler(url, { properties: params });
    return response?.data;
  }

  static async getListingsData(params?: string[]): Promise<object> {
    const url = getServiceURL(CommonAPI.getListingsDataServiceName);
    const response = await requestHandler(url, { properties: params });
    return response?.data;
  }

}
